exports.LANGUAGE_MAPPER = {
  pl: "pl-PL",
  en: "en-US",
};
